export const TYPE = {
  HOURS: "hh",
  MINUTES: "mm",
  SECONDS: "ss"
};
